import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Rating, Typography } from "@mui/material";
import { StyledLightGreenButton } from "@Styled/Common";
import CustomInput from "@Components/Basic/Input/CustomInput";
import { BootstrapDialogTitle } from ".";
import { IReview } from "@Interfaces/Api/Review";
import Spinner from "../Spinner";
import { useState } from "react";
import SuccesssBox from "@Components/Basic/SuccessBox";

interface WriteReviewProps {
  handleClose: Function;
  open: boolean;
  handleReviewSubmit: Function;
  handleRatingSubmit: Function;
  myReview?: IReview;
  buttonSpinner: boolean;
  isRatingSubmitted: boolean;
}
export default function WriteReview({
  handleClose,
  open,
  handleReviewSubmit,
  myReview,
  handleRatingSubmit,
  buttonSpinner,
  isRatingSubmitted,
}: WriteReviewProps) {
  const [rating, setRating] = useState<number>(myReview?.rating!);
  const [message, setMessage] = useState<string>(myReview?.message!);
  const [title, setTitle] = useState<string>(myReview?.title!);
  const [titleError, setTitleError] = useState(false);
  const [messageError, setMessageError] = useState(false);

  // React.useEffect(() => {
  //   if (myReview) {
  //     setRating(myReview.rating);
  //     if (myReview.message == "") {
  //       setMessage(message);
  //     } else {
  //       setMessage(myReview.message);
  //     }
  //     if (myReview.title == "") {
  //       setTitle(title);
  //     } else {
  //       setTitle(myReview.title);
  //     }
  //   }
  // }, [myReview]);

  const onSubmitReview = () => {
    const obj = {
      rating: rating,
      message: message,
      title: title,
    };
    setMessageError(true);
    setTitleError(true);

    if (title) {
      setTitleError(false);
      setMessageError(true);
    }
    if (message) {
      setMessageError(false);
      setTitleError(true);
    }
    if (message && title && rating) {
      setMessageError(false);
      setTitleError(false);
      handleReviewSubmit(obj);
    }
  };

  const handleSubmitRating = (e: any) => {
    const obj = {
      rating: e.target.value,
    };
    if (e.target.value) {
      handleRatingSubmit(obj);
    }
  };

  const handleMessageChange = (e: any) => {
    setMessage(e.target.value);
    if (e.target.value) {
      setMessageError(false);
    }
  };

  const handleTitleChange = (e: any) => {
    setTitle(e.target.value);
    if (e.target.value) {
      setTitleError(false);
    }
  };

  const handleRatingChange = (e: any) => {
    setRating(e.target.value);
  };

  return (
    <div>
      <Dialog open={open} onClose={() => handleClose()}>
        <BootstrapDialogTitle onClose={() => handleClose()}>
          <Typography variant="subtitle1">Review Rating</Typography>
        </BootstrapDialogTitle>

        <DialogContent dividers style={{ textAlign: "center" }}>
          {isRatingSubmitted && (
            <SuccesssBox
              isReviewModal={true}
              message="You successfully submitted rating."
            />
          )}
          <Rating
            name="rating"
            id="rating"
            value={rating}
            onClick={handleSubmitRating}
            onChange={handleRatingChange}
            sx={{ fontSize: { sm: "4rem", xs: "2.6rem" } }}
          />
          <br />
          <CustomInput
            id="title"
            name="title"
            label="Title"
            value={title}
            onChange={handleTitleChange}
            placeholder="Review title..."
            rows={2}
            maxRows={4}
            style={{ margin: "15px 0px" }}
            helperText={
              titleError && (
                <div style={{ color: "red" }}>Title is required</div>
              )
            }
          />
          <CustomInput
            id="message"
            name="message"
            label="What did you like or dislike?"
            value={message}
            onChange={handleMessageChange}
            placeholder="Message"
            multiline={true}
            rows={2}
            maxRows={4}
            style={{ margin: "15px 0px" }}
            helperText={
              messageError && (
                <div style={{ color: "red" }}>Message is required</div>
              )
            }
          />
          <StyledLightGreenButton
            type="submit"
            sx={{ marginTop: "1rem" }}
            onClick={onSubmitReview}
          >
            {buttonSpinner ? <Spinner spinColor={true} /> : ""} Submit review
          </StyledLightGreenButton>
        </DialogContent>
      </Dialog>
    </div>
  );
}
